// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.receipt .title {
  font-weight: 500;
  font-size: 22px;
  line-height: 28px;
  margin-bottom: 14px;
}

.receipt .price-container {
  display: flex;
  justify-content: space-between;
  -webkit-box-pack: justify;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  color: var(--dark-gray);
}

.receipt .price-container + .price-container {
  margin-top: 8px;
}

.receipt .price-wrapper {
  text-align: right;
  font-weight: 800;
}

.receipt .discount .price-wrapper {
  font-weight: 600;
  color: var(--orange);
}

.receipt .discount .text {
  font-weight: 500;
}

.receipt .price-wrapper .period-price-wrapper {
  font-weight: 700;
  display: flex;
  font-size: 14px;
  line-height: 18px;
  justify-content: flex-end;
}

.receipt hr {
  margin: 20px 0;
  height: 0;
  color: #DCDCDC;
  border-top-width: 1px;
}

.receipt .total-container {
  padding-bottom: 20px;
  margin-bottom: 20px;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  border-bottom: 1px solid #DCDCDC;
}

.receipt .total-container span{
  font-weight: 800;
  font-size: 22px;
  line-height: 29px;
}

.receipt .total-container .period-description-wrapper {
  margin-top: 15px;

  font-size: 12px;
  font-weight: 500;
  line-height: 15.6px;
  color: var(--dark-gray);
}

.receipt .total-container .period-price-wrapper {
  margin-top: 15px;

  font-size: 15px;
  font-weight: 700;
  line-height: 19.5px;
}

.receipt .total-container .price-wrapper {
  color: var(--orange);
}`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/components/components.receipt.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,SAAS;EACT,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;;EAEhB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;;EAEhB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB","sourcesContent":[".receipt .title {\n  font-weight: 500;\n  font-size: 22px;\n  line-height: 28px;\n  margin-bottom: 14px;\n}\n\n.receipt .price-container {\n  display: flex;\n  justify-content: space-between;\n  -webkit-box-pack: justify;\n  font-weight: 400;\n  font-size: 15px;\n  line-height: 20px;\n  color: var(--dark-gray);\n}\n\n.receipt .price-container + .price-container {\n  margin-top: 8px;\n}\n\n.receipt .price-wrapper {\n  text-align: right;\n  font-weight: 800;\n}\n\n.receipt .discount .price-wrapper {\n  font-weight: 600;\n  color: var(--orange);\n}\n\n.receipt .discount .text {\n  font-weight: 500;\n}\n\n.receipt .price-wrapper .period-price-wrapper {\n  font-weight: 700;\n  display: flex;\n  font-size: 14px;\n  line-height: 18px;\n  justify-content: flex-end;\n}\n\n.receipt hr {\n  margin: 20px 0;\n  height: 0;\n  color: #DCDCDC;\n  border-top-width: 1px;\n}\n\n.receipt .total-container {\n  padding-bottom: 20px;\n  margin-bottom: 20px;\n  display: flex;\n  -webkit-box-pack: justify;\n  justify-content: space-between;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 19px;\n  border-bottom: 1px solid #DCDCDC;\n}\n\n.receipt .total-container span{\n  font-weight: 800;\n  font-size: 22px;\n  line-height: 29px;\n}\n\n.receipt .total-container .period-description-wrapper {\n  margin-top: 15px;\n\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 15.6px;\n  color: var(--dark-gray);\n}\n\n.receipt .total-container .period-price-wrapper {\n  margin-top: 15px;\n\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 19.5px;\n}\n\n.receipt .total-container .price-wrapper {\n  color: var(--orange);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
